<template>
  <div class="articlemanagement">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="2">
          <Divider orientation="left">{{ langMap.taskScheduleTable[lang] }}</Divider>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="22">
          <Form :label-width="110" :model="searchForm">
            <div class="des-cardTittle-box">
              <FormItem :label="langMap.robot[lang]" class="leftFlex">
                <Select v-model="searchForm.robotId" clearable>
                  <Option :key="item.id" :value="item.id" v-for="item in robotList">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="langMap.task[lang]" class="leftFlex">
                <Select v-model="searchForm.taskId" clearable>
                  <Option :key="item.id" :value="item.id" v-for="item in taskList">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="langMap.status[lang]" class="leftFlex">
                <Select v-model="searchForm.status" clearable>
                  <Option :key="item.id" :value="item.id" v-for="item in scheduleStatusList">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="langMap.belongStation[lang]" class="leftFlex" prop="stationId">
                <Select v-model="searchForm.stationId" clearable>
                  <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <Button type="info" style="margin-left:20px;" @click="searchData">{{ langMap.search[lang] }}</Button>
              <Button type="primary" style="margin-left:20px;" @click="modelShow(true, null)">{{ langMap.add[lang]
                }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table :height="height" :loading="tableLoading" border :columns="col" :data="scheduleList"></Table>
      <!--分页数据-->
      <div style="text-align:center;padding-top:10px;" v-if="scheduleList.length > 0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

    <Modal :mask-closable="false" v-model="saveModal" :title="langMap.taskSchedule[lang]" :styles="{ width: '600px' }">
      <Form ref="formValidate" :model="saveForm" :rules="ruleValidate" :label-width="120" :key="formKey">
        <FormItem :label="langMap.task[lang]" prop="taskId">
          <Select v-model="saveForm.taskId" clearable @on-change="taskChange">
            <Option :key="item.id" :value="item.id" v-for="item in taskList">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <!--NEW ADD-->
        <FormItem :label="langMap.belongStation[lang]" prop="stationId" v-show="saveForm.taskId">
          <div>{{ getStationName(saveForm.stationId) }}</div>
        </FormItem>
        <FormItem :label="langMap.robot[lang]" prop="robotId" v-show="saveForm.taskId">
          <Select v-model="saveForm.robotId" clearable>
            <Option :key="item.id" :value="item.id" v-for="item in saveFormRobots">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <FormItem :label="langMap.priority[lang]" prop="priority" v-if="false">
          <Select v-model="saveForm.priority">
            <Option v-for="item in priorityList" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.executionMethod[lang]" prop="type">
          <Select v-model="saveForm.type">
            <Option v-for="item in scheduleTypeList" :value="item.id" :key="item.id"
              :disabled="saveForm.id !== '' && item.id === 6 ? true : false">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.executionTimes[lang]" prop="excuteNumber" v-if="false">
          <RadioGroup v-model="saveForm.unlimit" type="button">
            <Radio :label="langMap.unlimited[lang]" :disabled="saveForm.excuteNumberDisable"></Radio>
            <Radio :label="langMap.limited[lang]" :disabled="saveForm.excuteNumberDisable"></Radio>
          </RadioGroup>
          <span v-if="saveForm.unlimit === langMap.limited[lang]">
            {{ langMap.execute[lang] }}<InputNumber :min="1" v-model="saveForm.excuteNumber"
              :disabled="saveForm.excuteNumberDisable">
            </InputNumber>{{ langMap.times[lang] }}
          </span>
        </FormItem>
        <FormItem :label="langMap.executionTime[lang]" v-if="saveForm.type === 1" prop="excuteDateBegin">
          <DatePicker :value="saveForm.excuteDateBegin" @on-change="saveForm.excuteDateBegin = $event"
            format="yyyy-MM-dd" type="date" :placeholder="langMap.selectDate[lang]" style="width: 200px"
            :options="datePickerOptions"></DatePicker>
          <TimePicker :value="saveForm.excuteTimeBegin" @on-change="saveForm.excuteTimeBegin = $event" type="time"
            :placeholder="langMap.selectTime[lang]" style="width: 168px"
            :disabled-hours="disabledHours" :disabled-minutes="disabledMinutes" :disabled-seconds="disabledSeconds"></TimePicker>
        </FormItem>
        <!-- 每日 -->
        <FormItem :label="langMap.executionTime[lang]" v-if="saveForm.type === 2" prop="excuteDateBegin">
          <TimePicker v-if="saveForm.unlimit === langMap.unlimited[lang]" :value="saveForm.excuteTime"
            @on-change="saveForm.excuteTime = $event" type="timerange" placement="bottom-end"
            :placeholder="langMap.selectTimeRange[lang]" style="width: 168px"></TimePicker>
          <TimePicker v-if="saveForm.unlimit === langMap.limited[lang]" :value="saveForm.excuteTimeBegin"
            @on-change="saveForm.excuteTimeBegin = $event" type="time" :placeholder="langMap.selectTime[lang]"
            style="width: 168px"></TimePicker>
        </FormItem>
        <!-- 每周 -->
        <FormItem :label="langMap.executionTime[lang]" v-if="saveForm.type === 3" prop="excuteWeeks">
          <div>
            <div style="margin-bottom: 10px;">
              <CheckboxGroup v-model="saveForm.weeks">
                <Checkbox label="2">
                  <span>{{ langMap.monday[lang] }}</span>
                </Checkbox>
                <Checkbox label="3">
                  <span>{{ langMap.tuesday[lang] }}</span>
                </Checkbox>
                <Checkbox label="4">
                  <span>{{ langMap.wednesday[lang] }}</span>
                </Checkbox>
                <Checkbox label="5">
                  <span>{{ langMap.thursday[lang] }}</span>
                </Checkbox>
                <Checkbox label="6">
                  <span>{{ langMap.friday[lang] }}</span>
                </Checkbox>
                <Checkbox label="7">
                  <span>{{ langMap.saturday[lang] }}</span>
                </Checkbox>
                <Checkbox label="1">
                  <span>{{ langMap.sunday[lang] }}</span>
                </Checkbox>
              </CheckboxGroup>
              <div style="color: #f50; font-size: 12px; margin-top: 4px;" v-if="weekError">{{ weekError }}</div>
            </div>
            <div>
              <TimePicker v-if="saveForm.unlimit === langMap.unlimited[lang]" :value="saveForm.excuteTime"
                @on-change="saveForm.excuteTime = $event" type="timerange" placement="bottom-end"
                :placeholder="langMap.selectTimeRange[lang]" style="width: 168px"></TimePicker>
              <TimePicker v-if="saveForm.unlimit === langMap.limited[lang]" :value="saveForm.excuteTimeBegin"
                @on-change="saveForm.excuteTimeBegin = $event" type="time" :placeholder="langMap.selectTime[lang]"
                style="width: 168px"></TimePicker>
              <div style="color: #f50; font-size: 12px; margin-top: 4px;" v-if="timeError">{{ timeError }}</div>
            </div>
          </div>
        </FormItem>
        <!-- 每月 -->
        <FormItem :label="langMap.executionTime[lang]" v-if="saveForm.type === 4" prop="excuteDateBegin">
          {{ langMap.everyMonth[lang] }}<InputNumber :max="31" :min="1" :step="1" style="width: 60px"
            v-model="saveForm.excuteDayBegin" @input="handleDayBeginInput"></InputNumber>
          {{ langMap.to[lang] }}<InputNumber :max="31" :min="1" :step="1" style="width: 60px"
            v-model="saveForm.excuteDayEnd" @input="handleDayEndInput"></InputNumber>{{ langMap.day[lang] }}
          <TimePicker v-if="saveForm.unlimit === langMap.unlimited[lang]" :value="saveForm.excuteTime"
            @on-change="saveForm.excuteTime = $event" type="timerange" placement="bottom-end"
            :placeholder="langMap.selectTimeRange[lang]" style="width: 168px"></TimePicker>
          <TimePicker v-if="saveForm.unlimit === langMap.limited[lang]" :value="saveForm.excuteTimeBegin"
            @on-change="saveForm.excuteTimeBegin = $event" type="time" :placeholder="langMap.selectTime[lang]"
            style="width: 168px"></TimePicker>
        </FormItem>
        <!-- 每年 -->
        <FormItem :label="langMap.executionTime[lang]" v-if="saveForm.type === 5" prop="excuteDateBegin">
          {{ langMap.everyYear[lang] }}<InputNumber :max="12" :min="1" style="width: 50px"
            v-model="saveForm.excuteMonthBegin"></InputNumber>
          {{ langMap.to[lang] }}<InputNumber :max="12" :min="1" style="width: 50px"
            v-model="saveForm.excuteMonthEnd"></InputNumber>{{ langMap.month[lang] }}
          <br />{{ langMap.everyMonth[lang] }}<InputNumber :max="31" :min="1" :step="1" style="width: 60px"
            v-model="saveForm.excuteDayBegin" @input="handleDayBeginInput"></InputNumber>
          {{ langMap.to[lang] }}<InputNumber :max="31" :min="1" :step="1" style="width: 60px"
            v-model="saveForm.excuteDayEnd" @input="handleDayEndInput"></InputNumber>{{ langMap.day[lang] }}
          <TimePicker v-if="saveForm.unlimit === langMap.unlimited[lang]" :value="saveForm.excuteTime"
            @on-change="saveForm.excuteTime = $event" type="timerange" placement="bottom-end"
            :placeholder="langMap.selectTimeRange[lang]" style="width: 168px"></TimePicker>
          <TimePicker v-if="saveForm.unlimit === langMap.limited[lang]" :value="saveForm.excuteTimeBegin"
            @on-change="saveForm.excuteTimeBegin = $event" type="time" :placeholder="langMap.selectTime[lang]"
            style="width: 168px"></TimePicker>
        </FormItem>
        <FormItem :label="langMap.description[lang]">
          <Input v-model="saveForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
            :placeholder="langMap.robotDesc[lang]" />
        </FormItem>
        <Alert v-show="saveForm.taskId" type="warning">
          <b>{{ langMap.robotNote[lang] }}</b>：{{ langMap.robotNoteDesc1[lang] }}
          <template slot="desc">
            {{ langMap.robotNoteDesc2[lang] }}<br />
            {{ langMap.robotNoteDesc3[lang] }}
          </template>
        </Alert>
      </Form>
      <div slot="footer">
        <Button type="text" :loading="btnLoading" @click="cancel">{{ langMap.cancel[lang] }}</Button>
        <Button type="primary" :loading="btnLoading" @click="ok">{{ langMap.save[lang] }}</Button>
      </div>
    </Modal>

    <!-- Log Modal -->
    <Modal v-model="logModalVisible" :title="langMap.executionLog[lang]" :mask-closable="false" width="1000">
      <div style="height: 500px; overflow-y: auto; padding: 10px 0;">
        <Timeline pending v-if="logList.length > 0" style="padding: 0 20px;">
          <TimelineItem v-for="(item, index) in logList" :key="index">
            <!-- Header with status and dates -->
            <div style="margin-bottom: 14px; background: #f9f9f9; padding: 12px; border-radius: 4px;">
              <!-- Schedule Start Time and Create Time on Same Line -->
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <div style="display: flex; align-items: center; flex: 1;">
                  <span style="color: #2d8cf0; font-size: 11px; font-weight: 600; letter-spacing: 0.5px; background: #e6f1ff; padding: 3px 8px; border-radius: 3px; display: inline-block; margin-right: 10px;">{{ langMap.scheduleStartTime[lang] }}</span>
                  <span style="font-weight: 600; font-size: 13px; color: #1f2d3d; margin-right: 12px; font-family: 'Monaco', 'Menlo', monospace;">{{ item.scheduleTime }}</span>
                  <Tag :color="item.executeStatus === 1 ? 'green' : 'red'" style="margin: 0;">
                    {{ item.executeStatus === 1 ? langMap.success[lang] : langMap.failed[lang] }}
                  </Tag>
                </div>
                <div style="display: flex; align-items: center; justify-content: flex-end;">
                  <span style="color: #95a5a6; font-size: 11px; font-weight: 600; letter-spacing: 0.5px; background: #ecf0f1; padding: 3px 8px; border-radius: 3px; display: inline-block; margin-right: 10px;">{{ langMap.createTime[lang] }}</span>
                  <span style="color: #566573; font-size: 12px; font-family: 'Monaco', 'Menlo', monospace;">{{ item.createTime }}</span>
                </div>
              </div>
            </div>
            
            <!-- Failure reason - only show for failed executions -->
            <div v-if="item.executeStatus === 2" style="margin-top: 10px; padding: 10px; background-color: #fef0f0; border-left: 3px solid #ed4014; border-radius: 2px;">
              <p style="margin: 0; color: #ed4014;">
                <Icon type="ios-close-circle" style="margin-right: 5px;"></Icon>
                <strong>{{ langMap.failureReason[lang] }}:</strong>
              </p>
              <p style="margin: 8px 0 0 24px; color: #666;">
                {{ lang === 'en' ? item.failReasonEn : item.failReasonZh }}
              </p>
            </div>
          </TimelineItem>
        </Timeline>
        <div v-else style="text-align: center; padding: 40px 20px; color: #ccc;">
          <Icon type="ios-information-circle" size="48" style="margin-bottom: 10px; display: block;"></Icon>
          <p>{{ langMap.noExecutionLog[lang] }}</p>
        </div>
      </div>
      <div slot="footer" style="text-align: center; padding-top: 10px;">
        <Page 
          v-if="logTotal > 0"
          :current="logPageNum" 
          :total="logTotal" 
          :page-size="logPageSize" 
          @on-change="handleLogPageChange"
          style="text-align: center; margin-bottom: 15px;"
        ></Page>
      </div>
    </Modal>

  </div>
</template>

<script>
import api from "../../../api/index.js";
import { getItem } from '@/utils/mapUtil.js';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { t } from '@/utils/language';

export default {
  name: "ScheduleIndex",
  components: {},
  data() {
    //执行时间校验
    const validateDate = (rule, value, callback) => {
      if (this.saveForm.type === 1) {
        if (!this.saveForm.excuteDateBegin) {
          return callback(new Error(t('dateCannotBeEmpty')));
        } else if (!this.saveForm.excuteTimeBegin) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else {
          callback();
        }
      } else if (this.saveForm.type === 2) {
        if (this.saveForm.unlimit === t('unlimited') && !this.saveForm.excuteTime) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else if (this.saveForm.unlimit === t('unlimited') && this.saveForm.excuteTime && this.saveForm.excuteTime.length === 2 && this.saveForm.excuteTime[0] === this.saveForm.excuteTime[1]) {
          return callback(new Error(t('startAndEndTimeCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('limited') &&
          !this.saveForm.excuteTimeBegin
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else {
          callback();
        }
      } else if (this.saveForm.type === 3) {
        if (
          this.saveForm.unlimit === t('unlimited') &&
          !this.saveForm.excuteTime
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else if (this.saveForm.unlimit === t('unlimited') && this.saveForm.excuteTime && this.saveForm.excuteTime.length === 2 && this.saveForm.excuteTime[0] === this.saveForm.excuteTime[1]) {
          return callback(new Error(t('startAndEndTimeCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('limited') &&
          !this.saveForm.excuteTimeBegin
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else {
          callback();
        }
      } else if (this.saveForm.type === 4) {
        if (!this.saveForm.excuteDayBegin) {
          return callback(new Error(t('startDayCannotBeEmpty')));
        } else if (!this.saveForm.excuteDayEnd) {
          return callback(new Error(t('endDayCannotBeEmpty')));
        } else if (this.saveForm.excuteDayBegin > this.saveForm.excuteDayEnd) {
          return callback(new Error(t('startDayCannotGreaterThanEndDay')));
        } else if (this.saveForm.excuteDayBegin === this.saveForm.excuteDayEnd) {
          return callback(new Error(t('startAndEndDayCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('unlimited') &&
          !this.saveForm.excuteTime
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else if (this.saveForm.unlimit === t('unlimited') && this.saveForm.excuteTime && this.saveForm.excuteTime.length === 2 && this.saveForm.excuteTime[0] === this.saveForm.excuteTime[1]) {
          return callback(new Error(t('startAndEndTimeCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('limited') &&
          !this.saveForm.excuteTimeBegin
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else {
          callback();
        }
      } else if (this.saveForm.type === 5) {
        if (!this.saveForm.excuteMonthBegin) {
          return callback(new Error(t('startMonthCannotBeEmpty')));
        } else if (!this.saveForm.excuteMonthEnd) {
          return callback(new Error(t('endMonthCannotBeEmpty')));
        } else if (
          this.saveForm.excuteMonthBegin > this.saveForm.excuteMonthEnd
        ) {
          return callback(new Error(t('startMonthCannotGreaterThanEndMonth')));
        } else if (this.saveForm.excuteMonthBegin === this.saveForm.excuteMonthEnd) {
          return callback(new Error(t('startAndEndMonthCannotBeTheSame')));
        } else if (!this.saveForm.excuteDayBegin) {
          return callback(new Error(t('startDayCannotBeEmpty')));
        } else if (!this.saveForm.excuteDayEnd) {
          return callback(new Error(t('endDayCannotBeEmpty')));
        } else if (this.saveForm.excuteDayBegin > this.saveForm.excuteDayEnd) {
          return callback(new Error(t('startDayCannotGreaterThanEndDay')));
        } else if (this.saveForm.excuteDayBegin === this.saveForm.excuteDayEnd) {
          return callback(new Error(t('startAndEndDayCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('unlimited') &&
          !this.saveForm.excuteTime
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else if (this.saveForm.unlimit === t('unlimited') && this.saveForm.excuteTime && this.saveForm.excuteTime.length === 2 && this.saveForm.excuteTime[0] === this.saveForm.excuteTime[1]) {
          return callback(new Error(t('startAndEndTimeCannotBeTheSame')));
        } else if (
          this.saveForm.unlimit === t('limited') &&
          !this.saveForm.excuteTimeBegin
        ) {
          return callback(new Error(t('timeCannotBeEmpty')));
        } else {
          callback();
        }
      }
      callback();
    };
    //执行次数校验
    const validateExcuteNumber = (rule, value, callback) => {
      if (
        this.saveForm.unlimit === t('limited') &&
        (!this.saveForm.excuteNumber ||
          this.saveForm.excuteNumber === "" ||
          this.saveForm.excuteNumber < 1)
      ) {
        return callback(new Error(t('executionTimesCannotBeEmpty')));
      } else {
        callback();
      }
    };
    //任务id校验
    const validateTaskId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(t('taskCannotBeEmpty')));
      }
      callback();
    };
    const validateType = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(t('executionMethodCannotBeEmpty')));
      }
      callback();
    };
    const validateWeeks = (rule, value, callback) => {
      if (this.saveForm.type === 3 && this.saveForm.weeks.length < 1) {
        return callback(new Error(t('weekCannotBeEmpty')));
      }
      callback();
    };
    const _this = this;

    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      scheduleList: [],
      robotList: [],
      taskList: [],
      scheduleStatusList: [],
      scheduleTypeList: [],
      priorityList: [0, 1, 2, 3, 4, 5],
      btnLoading: false,
      saveModal: false,
      index: 1,
      total: 0,
      tableLoading: false,
      timeError: '',
      formKey: 0,
      currentTime: new Date(),
      currentDateTime: '',
      searchForm: {
        robotId: "",
        taskId: "",
        status: "",
        stationId:''
      },
      saveForm: {
        id: "",
        type: null,
        robotId: "",
        taskId: "",
        unlimit: t('unlimited'),
        excuteNumber: null,
        excuteNumberDisable: false,
        excuteDateBegin: null,
        excuteTime: null,
        excuteTimeBegin: null,
        excuteTimeEnd: null,
        excuteDayBegin: null,
        excuteDayEnd: null,
        excuteMonthBegin: null,
        excuteMonthEnd: null,
        priority: 0,
        description: "",
        weeks: [],
        excuteWeeks: "",
        stationId:''
      },
      saveFormRobots:[], // 弹框表单使用的机器人列表
      stationList: [], // 站点列表
      weekError: '',
      logModalVisible: false,
      logModalLoading: false,
      logScheduleId: null,
      logList: [],
      logPageNum: 1,
      logPageSize: 10,
      logTotal: 0,
      ruleValidate: {
        taskId: [
          { required: true, validator: validateTaskId, trigger: "change" }
        ],
        type: [
          { required: true, validator: validateType, trigger: "change" }
        ],
        excuteDateBegin: [
          { required: true, validator: validateDate, trigger: "change" }
        ],
        excuteWeeks: [
          { required: true, validator: validateWeeks, trigger: "change" }
        ],
        excuteNumber: [
          { required: true, validator: validateExcuteNumber, trigger: "change" }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    datePickerOptions() {
      return {
        disabledDate: this.disabledSingleDate
      };
    },
    disabledHours() {
      const today = new Date(this.currentTime);
      const selectedDate = this.saveForm.excuteDateBegin ? new Date(this.saveForm.excuteDateBegin) : null;
      
      if (!selectedDate) return [];
      
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // If selected date is today, disable hours before current hour
      if (selectedDate.getTime() === today.getTime()) {
        const currentHour = this.currentTime.getHours();
        const disabled = [];
        for (let i = 0; i < currentHour; i++) {
          disabled.push(i);
        }
        return disabled;
      }
      
      return [];
    },
    disabledMinutes() {
      const today = new Date(this.currentTime);
      const selectedDate = this.saveForm.excuteDateBegin ? new Date(this.saveForm.excuteDateBegin) : null;
      
      if (!selectedDate) return [];
      
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // If selected date is today, disable minutes before current minute
      if (selectedDate.getTime() === today.getTime()) {
        const currentMinute = this.currentTime.getMinutes();
        const disabled = [];
        for (let i = 0; i < currentMinute; i++) {
          disabled.push(i);
        }
        return disabled;
      }
      
      return [];
    },
    disabledSeconds() {
      const today = new Date(this.currentTime);
      const selectedDate = this.saveForm.excuteDateBegin ? new Date(this.saveForm.excuteDateBegin) : null;
      
      if (!selectedDate) return [];
      
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      
      // If selected date is today, disable seconds before current second
      if (selectedDate.getTime() === today.getTime()) {
        const currentSecond = this.currentTime.getSeconds();
        const disabled = [];
        for (let i = 0; i < currentSecond; i++) {
          disabled.push(i);
        }
        return disabled;
      }
      
      return [];
    },
    stationMap() {
      const _map = {};
      this.stationList.forEach(s => {
        _map[s.id] = s.name;
      });
      return _map;
    },
    col (){
      return [
      {
          title: langMap.taskName[this.lang],
          minWidth: 50,
          key: "taskName"
        },
        {
          title: langMap.robotName[this.lang],
          minWidth: 50,
          key: "robotName"
        },
        {
          title: langMap.serialNumber[this.lang],
          minWidth: 50,
          key: "robotCode"
        },
        // {
        //   title: langMap.priority[this.lang],
        //   width: 80,
        //   key: "priority"
        // },
        {
          title: langMap.belongStation[this.lang],
          width: 150,
          key: "stationId",
          render: (h, { row }) => {
            return h('span', this.stationMap[row.stationId])
          }
        },
        {
          title: langMap.executionMethod[this.lang],
          width: 145,
          key: "type",
          render: (h, { row }) => {
            let text = row.type;
            this.scheduleTypeList.forEach((item, index, arr) => {
              if (item.id == row.type) {
                text = item.name;
              }
            });
            return h("span", text);
          }
        },
        {
          title: langMap.executionTime[this.lang],
          width: 150,
          key: "executeDateBegin",
          render: (h, { row }) => {
            let text = "";
            if (row.type === 1) {
              text += row.excuteDateBegin + " " + row.excuteTimeBegin;
            } else if (row.type === 2) {
              text += " " + row.excuteTimeBegin;
              if (row.unlimit === langMap.unlimited[this.lang]) {
                text += langMap.to[this.lang] + row.excuteTimeEnd;
              }
            } else if (row.type === 3) {
              text += langMap.everyWeek[this.lang];
              row.weeks.forEach((item, index, array) => {
                switch (item) {
                  case "1":
                    text += langMap.sun[this.lang] + " ";
                    break;
                  case "2":
                    text += langMap.mon[this.lang] + " ";
                    break;
                  case "3":
                    text += langMap.tues[this.lang] + " ";
                    break;
                  case "4":
                    text += langMap.wednes[this.lang] + " ";
                    break;
                  case "5":
                    text += langMap.thurs[this.lang] + " ";
                    break;
                  case "6":
                    text += langMap.fri[this.lang] + " ";
                    break;
                  case "7":
                    text += langMap.satur[this.lang] + " ";
                    break;
                }
              });
              text += " " + row.excuteTimeBegin;
              if (row.unlimit === langMap.unlimited[this.lang]) {
                text += langMap.to[this.lang] + row.excuteTimeEnd;
              }
            } else if (row.type === 4) {
              text +=
                langMap.everyMonth[this.lang] + row.excuteDayBegin + langMap.to[this.lang] + row.excuteDayEnd + langMap.day[this.lang];
              text += " " + row.excuteTimeBegin;
              if (row.unlimit === langMap.unlimited[this.lang]) {
                text += langMap.to[this.lang] + row.excuteTimeEnd;
              }
            } else if (row.type === 5) {
              text +=
                langMap.everyYear[this.lang] +
                row.excuteMonthBegin +
                langMap.to[this.lang] +
                row.excuteMonthEnd +
                langMap.month[this.lang] + "，";
              text +=
                langMap.everyMonth[this.lang] + row.excuteDayBegin + langMap.to[this.lang] + row.excuteDayEnd + langMap.day[this.lang];
              text += " " + row.excuteTimeBegin;
              if (row.unlimit === langMap.unlimited[this.lang]) {
                text += langMap.to[this.lang] + row.excuteTimeEnd;
              }
            }
            return h("span", text);
          }
        },
        // {
        //   title: langMap.timesNumber[this.lang],
        //   key: "executeNumber",
        //   width: 120,
        //   render: (h, { row }) => {
        //     let text = row.excuteNumber;
        //     if (row.excuteNumber === -1) {
        //       text = langMap.unlimited[this.lang];
        //     }
        //     return h("span", text);
        //   }
        // },
        {
          title: langMap.status[this.lang],
          key: "status",
          width: 100,
          render: (h, { row }) => {
            let text = row.type;
            this.scheduleStatusList.forEach((item, index, arr) => {
              if (item.id == row.status) {
                text = item.name;
              }
            });
            return h("span", text);
          }
        },
        {
          title: langMap.updateTime[this.lang],
          key: "updateTime",
          width: 160,
          render(h, params) {
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModification[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 200,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            //立即执行不需要修改，原因是立即执行保存之后就生成了下发任务；
            if (params.row.type !== 6) {
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        this.modelShow(true, params.row);
                      }
                    }
                  },
                  langMap.modify[this.lang]
                )
              );
            }
            if (params.row.type !== 6) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
            }
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDeleteSchedule[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "task-server/schedule/delete/" + params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            if ((params.row.status === 1 || params.row.status === 2) && params.row.type !== 6) {
              //禁用启用判断
              let rendText = null;
              let newStatus = null;
              if (params.row.status === 1) {
                rendText = langMap.disable[this.lang];
                newStatus = 2;
              } else if (params.row.status === 2) {
                rendText = langMap.enable[this.lang];
                newStatus = 1;
              }
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "2px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: langMap.tips[this.lang],
                          content: langMap.confirmChangeScheduleStatus[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "task-server/schedule/enable/" +
                                params.row.id +
                                "?status=" +
                                newStatus,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tips[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  rendText
                )
              );
            }
            // Add log button at the end - show for all types except immediate execution
            if (params.row.type !== 6) {
              renderArray.push(
                h("Divider", {
                  props: {
                    type: "vertical"
                  },
                  style: {
                    margin: "0 2px"
                  }
                })
              );
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#19be6b"
                    },
                    on: {
                      click: () => {
                        this.showLogModal(params.row);
                      }
                    }
                  },
                  langMap.executionLog[this.lang]
                )
              );
            }
            return h("div", renderArray);
          }
        }
      ]
    }
  },
  methods: {
    //获取列表
    getList() {
      const _form = this.searchForm;
      const _sid = `&stationId=${_form.stationId || ''}`;
      this.tableLoading = true;
      _form.robotId = _form.robotId
        ? _form.robotId
        : "";
      _form.taskId = _form.taskId
        ? _form.taskId
        : "";
      _form.status = _form.status
        ? _form.status
        : "";

      api
        .getData(
          "task-server/schedule/list?index=" +
          this.index +
          "&robotId=" +
          _form.robotId +
          _sid+
          "&taskId=" + 
          _form.taskId +
          "&status=" +
          _form.status,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            //调整数据
            let list = res.data.rows;
            list.forEach((item, index, arr) => {
              if (item.type !== 1) {
                if (
                  item.excuteTimeBegin &&
                  item.excuteTimeBegin !== null &&
                  item.excuteTimeEnd &&
                  item.excuteTimeEnd !== null
                ) {
                  let excuteTime = [];
                  excuteTime[0] = item.excuteTimeBegin;
                  excuteTime[1] = item.excuteTimeEnd;
                  item.excuteTime = excuteTime;
                }
              }
              if (item.excuteNumber === -1) {
                item.unlimit = langMap.unlimited[this.lang];
              } else {
                item.unlimit = langMap.limited[this.lang];
              }
              if (item.type === 1) {
                item.unlimit = langMap.limited[this.lang];
                item.excuteNumberDisable = true;
              }
              if (item.excuteWeeks) {
                item.weeks = item.excuteWeeks.split(",");
              }
            });
            this.scheduleList = list;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    // 所有机器人
    getAllRobot() {

      api.getData("robot-server/robot/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.robotList = res.data
        }
      });
    },
    getRobotByStation(stationId) {
      api.getData("robot-server/robot/list/all/" + stationId, this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.saveFormRobots = res.data;
        }
      });
    },
    getTask() {
      api.getData("task-server/task/listAll?status=2", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.taskList = res.data;
        }
      });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    // 任务改变
    taskChange(val) {
      const [task, ix] = getItem(this.taskList, val, 'id');
      //console.log('[taskChange LOG]', task);
      this.saveForm.stationId = task.stationId;
      this.getRobotByStation(task.stationId || '');
    },
    // 任务变化后获取站点name
    getStationName(id) {
      const [point, jx] = getItem(this.stationList, id, 'id');
      //console.log('[this.stationList]', this.stationList,id,point);
      if (point) return point.name;
      else return '';
    },
    modelShow(flag, data) {
      this.weekError = '';
      this.timeError = '';
      if (data) {
        this.taskChange(data.taskId);
        this.saveForm = { ...data };
        // If editing and type is already single execution (1), get current time
        if (data.type === 1) {
          this.getCurrentTime();
        }
      } else {
        this.saveForm = {
          id: "",
          type: null,
          robotId: "",
          taskId: "",
          unlimit: langMap.unlimited[this.lang],
          excuteNumber: null,
          excuteNumberDisable: false,
          excuteDateBegin: null,
          excuteTime: null,
          excuteTimeBegin: null,
          excuteTimeEnd: null,
          excuteDayBegin: null,
          excuteDayEnd: null,
          excuteMonthBegin: null,
          excuteMonthEnd: null,
          description: "",
          priority: 0,
          weeks: [],
          excuteWeeks: ""
        };
      }
      this.saveModal = flag;
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      this.$refs["formValidate"].validate(valid => {
        if (!valid) return;
        const _saveForm = this.saveForm;
        // Check if time is selected for weekly schedule
        if (_saveForm.type === 3) {
          if (_saveForm.unlimit === t('unlimited') && !_saveForm.excuteTime) {
            this.timeError = t('timeCannotBeEmpty');
            return;
          } else if (_saveForm.unlimit === t('unlimited') && _saveForm.excuteTime && _saveForm.excuteTime.length === 2 && _saveForm.excuteTime[0] === _saveForm.excuteTime[1]) {
            this.timeError = t('startAndEndTimeCannotBeTheSame');
            return;
          } else if (_saveForm.unlimit === t('limited') && !_saveForm.excuteTimeBegin) {
            this.timeError = t('timeCannotBeEmpty');
            return;
          } else {
            this.timeError = '';
          }
        }
        // Execute immediately but no robot selected
        if (_saveForm.type === 6 && !_saveForm.robotId) {
          this.$Notice.warning({
            title: langMap.promptFromSystem[this.lang],
            desc: langMap.robotRequiredForImmediate[this.lang],
          });
          return;
        }
        // Prevent duplicate clicks
        if (this.btnLoading) return;
        //调整数据
        if (_saveForm.type !== 1 && _saveForm.unlimit === langMap.unlimited[this.lang]) {
            if (
              _saveForm.excuteTime &&
              _saveForm.excuteTime.length === 2
            ) {
              _saveForm.excuteTimeBegin = _saveForm.excuteTime[0];
              _saveForm.excuteTimeEnd = _saveForm.excuteTime[1];
            }
        }
        if (_saveForm.unlimit === langMap.unlimited[this.lang]) {
            _saveForm.excuteNumber = -1;
        }
          if (_saveForm.type === 3) {
              _saveForm.excuteWeeks = _saveForm.weeks.sort((a, b) => {
                const aNum = Number(a);
                const bNum = Number(b);
                if (aNum === 1) return 1;
                if (bNum === 1) return -1;
                return aNum - bNum;
              }).toString();
          }
          
        this.btnLoading = true;

        api.postData("task-server/schedule/save", _saveForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.promptFromSystem[this.lang],
                  desc: langMap.operationSuccess[this.lang],
                });
                this.getList();
                this.saveModal = false;
              }
            }).catch(er=>{ this.btnLoading = false; });

      });
    },
    handleDayBeginInput(val) {
      this.$nextTick(() => {
        if (this.saveForm.excuteDayBegin > 31) {
          this.saveForm.excuteDayBegin = 31;
        } else if (this.saveForm.excuteDayBegin < 1 && this.saveForm.excuteDayBegin !== null && this.saveForm.excuteDayBegin !== undefined && this.saveForm.excuteDayBegin !== '') {
          this.saveForm.excuteDayBegin = 1;
        }
      });
    },
    handleDayEndInput(val) {
      this.$nextTick(() => {
        if (this.saveForm.excuteDayEnd > 31) {
          this.saveForm.excuteDayEnd = 31;
        } else if (this.saveForm.excuteDayEnd < 1 && this.saveForm.excuteDayEnd !== null && this.saveForm.excuteDayEnd !== undefined && this.saveForm.excuteDayEnd !== '') {
          this.saveForm.excuteDayEnd = 1;
        }
      });
    },
    cancel() {
      this.saveModal = false;
    },
    getDic() {
      api.getData("task-server/path/get/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.scheduleStatusList = res.data.scheduleStatus;
          this.scheduleTypeList = res.data.scheduleType;
        }
      });
    },
    // 获取站点列表
    getStationList() {
      return api.getData("task-server/robotStation/list/all", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      });
    },
    getCurrentTime() {
      api.getData("system-server/sys/currentTime", this).then(res => {
        if (res.state === 1 && res.data && res.data.time) {
          // Parse datetime string format: "2026-01-20 15:47:07"
          const datetimeStr = res.data.time;
          this.currentDateTime = datetimeStr;
          // Convert to Date object: replace space with 'T' for ISO format
          this.currentTime = new Date(datetimeStr.replace(' ', 'T'));
        }
      });
    },
    disabledSingleDate(date) {
      const today = new Date(this.currentTime);
      today.setHours(0, 0, 0, 0);
      return date && date < today;
    },
    showLogModal(row) {
      this.logScheduleId = row.id;
      this.logPageNum = 1;
      this.logList = [];
      this.logModalVisible = true;
      this.getLogData();
    },
    getLogData() {
      this.logModalLoading = true;
      api.getData(
        `task-server/taskScheduleLog/detail/${this.logScheduleId}?pageNum=${this.logPageNum}&pageSize=${this.logPageSize}`,
        this
      ).then(res => {
        this.logModalLoading = false;
        if (res.state === 1 && res.data) {
          this.logList = res.data.rows || [];
          this.logTotal = res.data.total || 0;
        } else {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg || '获取日志失败'
          });
        }
      }).catch(err => {
        this.logModalLoading = false;
        this.$Notice.error({
          title: langMap.tip[this.lang],
          desc: '获取日志出错'
        });
      });
    },
    handleLogPageChange(page) {
      this.logPageNum = page;
      this.getLogData();
    },
  },
  watch: {
    "saveForm.type"(newValue, oldValue) {
      if (newValue) {
        this.saveForm.unlimit = t('limited');
        this.saveForm.excuteNumber = 1;
        this.saveForm.excuteNumberDisable = true;
        // Get current time when selecting single execution type (type 1)
        if (newValue === 1) {
          this.getCurrentTime();
        }
      } else {
        this.saveForm.excuteNumberDisable = false;
      }
      // Clear custom validation errors when switching execution method
      this.weekError = '';
      this.timeError = '';
      // Force Form re-render when type changes
      if (oldValue !== undefined && oldValue !== null) {
        this.formKey++;
      }
    },
    "saveForm.unlimit"(newValue, oldValue) {
      if (
        newValue === t('limited') &&
        oldValue === t('unlimited') &&
        this.saveForm.excuteNumber === -1
      ) {
        this.saveForm.excuteNumber = "";
      }
    },
    "saveForm.weeks"(newValue) {
      // Clear week error when weeks are selected
      if (newValue && newValue.length > 0) {
        this.weekError = '';
      }
    },
    "saveForm.excuteTime"(newValue) {
      // Clear time error when time is selected for unlimited mode
      if (this.saveForm.type === 3 && newValue) {
        this.timeError = '';
      }
    },
    "saveForm.excuteTimeBegin"(newValue) {
      // Clear time error when time is selected for limited mode
      if (this.saveForm.type === 3 && newValue) {
        this.timeError = '';
      }
      
      // For type 1 (single execution), adjust minutes/seconds if they become disabled
      if (this.saveForm.type === 1 && newValue) {
        const timeParts = newValue.split(':');
        if (timeParts.length === 3) {
          const hour = parseInt(timeParts[0], 10);
          const minute = parseInt(timeParts[1], 10);
          const second = parseInt(timeParts[2], 10);
          
          const today = new Date(this.currentTime);
          const selectedDate = this.saveForm.excuteDateBegin ? new Date(this.saveForm.excuteDateBegin) : null;
          
          if (selectedDate) {
            today.setHours(0, 0, 0, 0);
            selectedDate.setHours(0, 0, 0, 0);
            
            // If selected date is today
            if (selectedDate.getTime() === today.getTime()) {
              const currentHour = this.currentTime.getHours();
              const currentMinute = this.currentTime.getMinutes();
              const currentSecond = this.currentTime.getSeconds();
              
              let needsUpdate = false;
              let newHour = hour;
              let newMinute = minute;
              let newSecond = second;
              
              // If hour is current hour and minute is less than current minute, adjust minute
              if (hour === currentHour && minute < currentMinute) {
                newMinute = currentMinute;
                newSecond = 0;
                needsUpdate = true;
              }
              // If hour:minute matches current time and second is less than current second, adjust second
              else if (hour === currentHour && minute === currentMinute && second < currentSecond) {
                newSecond = currentSecond;
                needsUpdate = true;
              }
              
              if (needsUpdate) {
                this.$nextTick(() => {
                  this.saveForm.excuteTimeBegin = `${String(newHour).padStart(2, '0')}:${String(newMinute).padStart(2, '0')}:${String(newSecond).padStart(2, '0')}`;
                });
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getDic();
    this.getList();
    this.getAllRobot();
    this.getTask();
    this.getStationList();
  }
};
</script>

<style></style>
